<script lang="ts" setup>
const { t: $t } = useI18n()

import type { ApiQuickSaleGetAllByMachineryId, CreateQuickSale } from '~/types'

const props = defineProps<{ machineryId: string, isCreationDisabled?: boolean }>()
defineEmits<{ (e: 'createQuickSale', data: CreateQuickSale): void }>()

const { quickSale } = useQuery()
const { data, isLoading } = quickSale.allByMachineryId(props.machineryId, true)

const quickSaleColumn = computed((): OneDataColumn<ApiQuickSaleGetAllByMachineryId>[] => [
  {
    title: $t('customerModule.quickSale.description.label'),
    key: 'description',
  },
  {
    title: $t('customerModule.quickSale.createdAt.label'),
    key: 'createdAt',
    render: ({ createdAt }) => useDateAsString(createdAt),
  },
  {
    title: $t('customerModule.quickSale.createdBy.label'),
    key: 'createdBy',
    render: ({ createdBy, createdByEmail }) => createdBy.name ?? createdByEmail,
  },
])

const popupPdf = ref<null | { id: string, description: string }>(null)
</script>

<template>
  <CustomerModuleDataCard :title="$t('customerModule.quickSale.title')" :is-loading="isLoading">
    <QuickSalePopupPdf
      v-if="popupPdf"
      :payload="popupPdf"
      @close="popupPdf = null"
    />

    <template #headerExtra>
      <n-button
        type="primary"
        size="large"
        :disabled="isCreationDisabled"
        @click="$emit('createQuickSale', { machineryId, description: '', includeVAT: true })"
      >
        <template #icon>
          <Icon name="material-symbols:point-of-sale" />
        </template>
        {{ $t('customerModule.machinery.details.createQuickSale.title') }}
      </n-button>
    </template>

    <CustomerModuleList
      :data="data ?? []"
      :action-buttons="() => ['pdf']"
      :columns="quickSaleColumn"
      @pdf="row => popupPdf = row"
    />
  </CustomerModuleDataCard>
</template>
